<section class="business-hero">
  <div class="business-hero-inner">
    <div class="business-hero-text">
      <p class="eyebrow">For every kind of business</p>
      <h1>One ERP that runs <span class="accent">your way</span> of doing business</h1>
      <p class="subtitle">
        Retail counters, production floors, school offices, or clinics — orderYaa adapts its
        modules to how your business actually operates, instead of forcing you to adapt to it.
      </p>

      <div class="business-hero-actions">
        <button type="button" class="btn-primary" (click)="bookMeeting()">{{ ctaLinks.meeting.text }}</button>
        <a class="btn-secondary" routerLink="/pricing">See pricing</a>
      </div>
    </div>

    <div class="business-hero-visual" aria-hidden="true">
      <div class="visual-tile tile-1">
        <span class="tile-icon"><img src="images/mobilizers/pos.png" alt="" /></span>
        <span class="tile-label">Retail</span>
      </div>
      <div class="visual-tile tile-2">
        <span class="tile-icon"><img src="images/webps/manufacturing.svg" alt="" /></span>
        <span class="tile-label">Manufacturing</span>
      </div>
      <div class="visual-tile tile-3">
        <span class="tile-icon"><img src="images/mobilizers/hims.png" alt="" /></span>
        <span class="tile-label">Healthcare</span>
      </div>
      <div class="visual-tile tile-4">
        <span class="tile-icon"><img src="images/mobilizers/school.png" alt="" /></span>
        <span class="tile-label">Education</span>
      </div>
      <div class="visual-tile tile-5">
        <span class="tile-icon"><img src="images/webps/procurement.svg" alt="" /></span>
        <span class="tile-label">Procurement</span>
      </div>
      <div class="visual-tile tile-6">
        <span class="tile-icon"><img src="images/webps/sales.svg" alt="" /></span>
        <span class="tile-label">Sales</span>
      </div>
    </div>
  </div>
</section>
